import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { getHouseBillingHistory } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.api';
import { HouseBillingHistoryItem } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.types';
import { shouldFetchHouseBillingHistory } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.selectors';

type FetchHouseBillingHistoryParams = {
    force?: boolean;
    houseId: number;
};

export const fetchHouseBillingHistory = createAsyncThunk<HouseBillingHistoryItem[], FetchHouseBillingHistoryParams>(
    'la/ui/houseBillingHistory/fetchHouseBillingHistory',
    async ({ houseId }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const { payload } = await getHouseBillingHistory({
            authToken,
            deployment,
            houseId,
        });
        return payload;
    },
    {
        condition: ({ force, houseId }, { getState }) => force || shouldFetchHouseBillingHistory(getState(), houseId),
    }
);
